import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.css";
import BottomSheetModal from "../../components/BottomSheet";
import DropDownSelection from "../../components/DropDownSelection/DropDownSelection";
import Axios from "../../configs/serviceProvider/Axios";
import API from "../../configs/API";
import { CoinContext } from "../../configs/context/CoinContextProvider";

function BusinessContainer(props) {
  const {
    businessName,
    setBusinessName,
    selectedIndustry,
    setSelectedIndustry,
    openIndustryBottomSheet,
    setOpenIndustryBottomSheet,
    businessNumber,
    setBusinessNumber,
    businessTIN,
    setBusinessTIN,
  } = props;

  const { selectedLanguage } = useContext(CoinContext);
  const [industryList, setIndustryList] = useState([]);
  const { t } = useTranslation();

  const closeIndustryModal = () => setOpenIndustryBottomSheet(false);
  const openIndustryModal = () => setOpenIndustryBottomSheet(true);

  const radioOnClick = (item) => setSelectedIndustry(item);

  useEffect(() => {
    if (selectedIndustry) closeIndustryModal();
  }, [selectedIndustry]);

  useEffect(() => {
    getIndustryList();
  }, []);

  const getIndustryList = async () => {
    try {
      const result = await Axios.get(API.GET_INDUSTRY_LIST);
      if (result.status === 200 && result.data) {
        setIndustryList(result.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const setterMap = {
    businessName: setBusinessName,
    businessNumber: setBusinessNumber,
    businessTIN: setBusinessTIN,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (setterMap[name]) {
      setterMap[name](value);
    }
  };

  return (
    <>
      {openIndustryBottomSheet && (
        <BottomSheetModal
          openModal={openIndustryBottomSheet}
          onDismiss={closeIndustryModal}
          className="industry-bottom-sheet"
        >
          <div className="dropdown-selection">
            {industryList?.businessSector?.length > 0 && (
              <div>
                {industryList.businessSector.map((item) => (
                  <DropDownSelection
                    key={item.business_sector_id}
                    data={item}
                    name={selectedLanguage === "en" ? item.business_sector_name_en : item.business_sector_name_bm}
                    radioOnClick={radioOnClick}
                    checked={selectedIndustry.business_sector_id === item.business_sector_id}
                  />
                ))}
              </div>
            )}
          </div>
        </BottomSheetModal>
      )}

      <div className="row justify-content-center" style={{ marginTop: 16 }}>
        <div className="col-12 col-lg-6">
          {/* Business Name */}
          <div className="mb-3">
            <label htmlFor="businessName" className="form-label business-subtitle">
              {t("BUSINESS_NAME")} <span className="optional">{`(${t("OPTIONAL")})`}</span>
            </label>
            <input
              type="text"
              className="form-control py-2"
              id="businessName"
              name="businessName"
              placeholder={t("BUSINESS_NAME_PLACEHOLDER")}
              value={businessName}
              onChange={handleInputChange}
            />
          </div>

          {/* Industry */}
          <div className="mb-3">
            <label htmlFor="businessIndustry" className="form-label business-subtitle">
              {t("BUSINESS_INDUSTRY")} <span className="optional">{`(${t("OPTIONAL")})`}</span>
            </label>
            <div
              role="button"
              tabIndex={0}
              onClick={openIndustryModal}
              onKeyDown={openIndustryModal}
              className="d-flex align-items-center justify-content-between form-control py-2"
            >
              <input
                type="text"
                className="border-0 bg-white w-100 industry-dropdown"
                id="dropdownMenuButton1"
                placeholder={t("BUSINESS_INDUSTRY_PLACEHOLDER")}
                disabled
                value={
                  selectedLanguage === "en"
                    ? selectedIndustry.business_sector_name_en
                    : selectedIndustry.business_sector_name_bm
                }
              />
              <i className="fa-solid fa-chevron-down" style={{ color: "#909090" }} />
            </div>
          </div>

          {/* Company Number */}
          <div className="mb-3">
            <label htmlFor="businessNumber" className="form-label business-subtitle">
              {t("BUSINESS_COMPANY_NUMBER")} <span className="optional">{`(${t("OPTIONAL")})`}</span>
            </label>
            <input
              type="text"
              className="form-control py-2"
              id="businessNumber"
              name="businessNumber"
              placeholder={t("BUSINESS_COMPANY_NUMBER_PLACEHOLDER")}
              value={businessNumber}
              onChange={handleInputChange}
            />
          </div>

          {/* Business TIN */}
          <div className="mb-3">
            <label htmlFor="businessTIN" className="form-label business-subtitle">
              {t("BUSINESS_TIN")} <span className="optional">{`(${t("OPTIONAL")})`}</span>
            </label>
            <input
              type="text"
              className="form-control py-2"
              id="businessTIN"
              name="businessTIN"
              placeholder={t("BUSINESS_TIN_PLACEHOLDER")}
              value={businessTIN}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default BusinessContainer;
